var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "widget-container"
  }, [_c('div', {
    staticClass: "widget-list-container"
  }, [_vm._l(_vm.getDonationGoal, function (widget) {
    return _c('goal-widget-card', {
      key: widget.id,
      attrs: {
        "widget": widget
      },
      on: {
        "edit": function edit($event) {
          return _vm.onShownForm(widget);
        },
        "remove": _vm.onRemoveWidget,
        "status": _vm.onChangeStatusWidget
      }
    });
  }), _vm.isDesktop ? _c('add-goal-widget-card', {
    on: {
      "click": _vm.onShownForm
    }
  }) : _c('circle-button', {
    on: {
      "click": _vm.onShownForm
    }
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }